import Http from './../http';
import axios from 'axios';

var prefix = '/get-response';

export const getCampaigns = (token) => {
  return Http.api().get(`${prefix}/get-campaigns/` + token);
};

export const getFields = (token) => {
  return Http.api().get(`${prefix}/get-fields/` + token);
};

export const submitForm = (token, data, campaign) => {
  var obj = {
    'email' : data.email,
    'name' : data.name,
    "campaign": {
      "campaignId": campaign
    },
    "customFieldValues": []
  }

  delete data.email
  delete data.name

  for(var k in data) {
      var field = {
        "customFieldId": k,
        "value": [
          data[k]
        ]
      }
      obj.customFieldValues.push(field);
  }
  
  return Http.api().post(`${prefix}/contacts/` + token, obj);

}


// WEBPACK FOOTER //
// ./src/js/services/editor/getresponse.js